var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"metric-card"},[_c('p',{staticClass:"metric-value mb-1"},[_vm._v(_vm._s(_vm.value))]),_c('p',{staticClass:"metric-label mb-2"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"metric-track"},[_c('div',{staticClass:"metric-fill",style:({ width: `${_vm.progress}%` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }